export default function Datenschutz() {
    return (
        <div data-testid="datenschutz-page" className="bg-aimploy-bg">
            <section className="pt-24 lg:pt-32 pb-12 bg-aimploy-bg relative overflow-hidden">
                <div className="absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-aimploy-violet/10 blur-3xl" />
                <div className="relative max-w-[900px] mx-auto px-6 lg:px-12">
                    <span className="text-xs uppercase tracking-[0.2em] text-aimploy-violet font-semibold">Rechtliches</span>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight mt-6">
                        Datenschutz
                    </h1>
                    <p className="text-aimploy-muted mt-6 max-w-2xl">
                        Diese Datenschutzerklärung informiert Sie über Art, Umfang und Zweck der Verarbeitung
                        personenbezogener Daten auf dieser Website gemäß DSGVO und BDSG. Stand: April 2026.
                    </p>
                </div>
            </section>

            <section className="pb-24 lg:pb-32 bg-aimploy-bg">
                <div className="max-w-[900px] mx-auto px-6 lg:px-12">
                    <div className="bg-white rounded-3xl p-8 lg:p-12 border border-black/5 space-y-10 prose-content">
                        <Section title="1. Verantwortlicher" k="ds.1">
                            <p>
                                Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der DSGVO ist:<br />
                                <strong>aimploy UG (haftungsbeschränkt)</strong><br />
                                Leopoldstraße 2–8<br />
                                32051 Herford<br />
                                Deutschland<br />
                                E-Mail: <a className="text-aimploy-violet underline" href="mailto:kontakt@aimploy.de">kontakt@aimploy.de</a><br />
                                Telefon: +49 175 3669882
                            </p>
                        </Section>

                        <Section title="2. Server-Logfiles" k="ds.2">
                            <p>
                                Beim Besuch dieser Website werden automatisch technisch notwendige Daten (IP-Adresse,
                                Datum/Uhrzeit, aufgerufene URL, Referrer, User-Agent) verarbeitet. Diese werden ausschließlich
                                zur Sicherheit, Fehleranalyse und Missbrauchsabwehr verwendet und nach 30 Tagen gelöscht.
                                Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
                            </p>
                        </Section>

                        <Section title="3. Cookies & lokale Speicherung" k="ds.3">
                            <p>
                                Wir setzen ausschließlich technisch notwendige Cookies und lokale Speichertechniken ein:
                            </p>
                            <ul>
                                <li><code>aimploy_cookie_consent_v1</code> (localStorage) – speichert Ihre Cookie-Einwilligung</li>
                                <li><code>aimploy_exit_intent_shown</code> (sessionStorage) – verhindert wiederholtes Einblenden des Lead-Magnet-Overlays</li>
                                <li><code>aimploy_token</code> (localStorage, nur Admin-Bereich) – Login-Sitzung</li>
                                <li><code>access_token</code> (httpOnly-Cookie, nur Admin-Bereich) – Login-Sitzung</li>
                            </ul>
                            <p>
                                Es findet kein Tracking, keine Webanalyse und kein Marketing-Cookie-Einsatz statt.
                                Rechtsgrundlage: § 25 Abs. 2 Nr. 2 TTDSG (technisch erforderlich).
                            </p>
                        </Section>

                        <Section title="4. Kontaktformular" k="ds.4">
                            <p>
                                Bei Nutzung des Kontaktformulars verarbeiten wir Name, E-Mail-Adresse, ggf. Unternehmen
                                sowie Ihre Nachricht zum Zweck der Bearbeitung Ihrer Anfrage.
                                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertraglich) bzw. lit. f.
                                Speicherdauer: bis zur Erledigung der Anfrage zzgl. handelsrechtlicher Aufbewahrungsfristen.
                            </p>
                        </Section>

                        <Section title="5. Bewerberdatenverarbeitung" k="ds.5">
                            <p>
                                Im Rahmen einer Bewerbung verarbeiten wir Ihre Stammdaten (Name, E-Mail, Telefon),
                                gewünschte Position, Wunschgehalt sowie den von Ihnen hochgeladenen Lebenslauf
                                (PDF/DOCX). Lebensläufe enthalten regelmäßig weitere personenbezogene Daten
                                (z. B. Anschrift, Berufserfahrung, ggf. Foto, Geburtsdatum) sowie unter Umständen
                                besondere Kategorien personenbezogener Daten i. S. d. Art. 9 DSGVO.
                            </p>
                            <p>
                                Zweck: Vermittlung an passende Unternehmen, Matching mit offenen Stellen.
                                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO i. V. m. § 26 Abs. 1 BDSG, bei besonderen
                                Kategorien Art. 9 Abs. 2 lit. b DSGVO. Die Weitergabe Ihrer Daten an unsere Kunden
                                (Unternehmen) erfolgt ausschließlich nach Ihrer ausdrücklichen Einwilligung im
                                Einzelfall (Art. 6 Abs. 1 lit. a DSGVO).
                            </p>
                            <p>
                                Speicherdauer: 6 Monate nach Abschluss des Auswahlverfahrens (AGG-Klagefrist).
                                Aufnahme in einen Talent-Pool nur mit gesonderter Einwilligung.
                            </p>
                        </Section>

                        <Section title="6. Lead-Magnet (Recruiting-Playbook)" k="ds.6">
                            <p>
                                Beim Anfordern unseres Recruiting-Playbooks verarbeiten wir Name, E-Mail-Adresse und
                                Erfassungsquelle. Die Bestätigung erfolgt im Double-Opt-In-Verfahren: Sie erhalten
                                zunächst eine Bestätigungs-Mail; erst nach Klick auf den Bestätigungslink senden wir
                                Ihnen das PDF zu.
                            </p>
                            <p>
                                Zweck: Versand des PDFs und ggf. weitere thematisch verwandte Informationen.
                                Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                                Sie können Ihre Einwilligung jederzeit widerrufen, z. B. über den Abmelde-Link in jeder Mail
                                oder per E-Mail an hello@aimploy.de.
                            </p>
                        </Section>

                        <Section title="7. Newsletter" k="ds.7">
                            <p>
                                Für den Newsletter-Versand nutzen wir das Double-Opt-In-Verfahren. Die im Anmeldevorgang
                                gespeicherte IP-Adresse und Anmeldezeit dienen der Nachweisbarkeit der Einwilligung.
                                Eine Abmeldung ist über den Abmelde-Link in jeder Mail oder formlos per Mail möglich.
                            </p>
                        </Section>

                        <Section title="8. Auftragsverarbeiter & Drittanbieter" k="ds.8">
                            <p>Wir setzen folgende Auftragsverarbeiter ein, mit denen jeweils Verträge nach Art. 28 DSGVO bestehen:</p>
                            <ul>
                                <li><strong>Resend (Resend Labs Inc., USA)</strong> – Versand transaktionaler E-Mails (Bestätigungen, PDF-Versand). EU-Standardvertragsklauseln liegen vor.</li>
                                <li><strong>Emergent Object Storage</strong> – Sichere Speicherung hochgeladener Lebensläufe und PDFs.</li>
                                <li><strong>MongoDB / Hosting</strong> – Datenbankspeicherung der Formularinhalte.</li>
                                <li><strong>Cloudflare</strong> – Reverse-Proxy/CDN zur Auslieferung der Website.</li>
                                <li><strong>Google LLC (Google Calendar Appointment Schedules)</strong> – Terminbuchung über externen Link. Beim Klick auf den Buchungs-Button verlassen Sie unsere Seite. Datenschutz: <a className="text-aimploy-violet underline" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">policies.google.com/privacy</a></li>
                            </ul>
                        </Section>

                        <Section title="9. Social-Media-Links" k="ds.9">
                            <p>
                                Im Footer verlinken wir auf unsere Profile bei LinkedIn und Instagram. Es werden keine
                                Plug-ins eingebunden — eine Datenübertragung an die jeweiligen Anbieter erfolgt erst,
                                wenn Sie aktiv den Link anklicken. Die Datenschutzbestimmungen der Anbieter gelten dann
                                jeweils:
                            </p>
                            <ul>
                                <li>LinkedIn: <a className="text-aimploy-violet underline" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/legal/privacy-policy">linkedin.com/legal/privacy-policy</a></li>
                                <li>Instagram: <a className="text-aimploy-violet underline" target="_blank" rel="noopener noreferrer" href="https://privacycenter.instagram.com/policy">privacycenter.instagram.com/policy</a></li>
                            </ul>
                        </Section>

                        <Section title="10. Ihre Rechte" k="ds.10">
                            <p>Ihnen stehen folgende Rechte zu:</p>
                            <ul>
                                <li>Auskunft (Art. 15 DSGVO)</li>
                                <li>Berichtigung (Art. 16 DSGVO)</li>
                                <li>Löschung (Art. 17 DSGVO)</li>
                                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                                <li>Widerspruch (Art. 21 DSGVO)</li>
                                <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
                                <li>Beschwerde bei der zuständigen Aufsichtsbehörde — für uns: Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen, Kavalleriestraße 2-4, 40213 Düsseldorf.</li>
                            </ul>
                            <p>Zur Wahrnehmung Ihrer Rechte genügt eine formlose Mail an <a className="text-aimploy-violet underline" href="mailto:hello@aimploy.de">hello@aimploy.de</a>.</p>
                        </Section>

                        <Section title="11. SSL/TLS-Verschlüsselung" k="ds.11">
                            <p>
                                Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Sie erkennen
                                eine verschlüsselte Verbindung am Schloss-Symbol Ihres Browsers und am Präfix
                                <code> https://</code>.
                            </p>
                        </Section>

                        <Section title="12. Änderungen" k="ds.12">
                            <p>
                                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den
                                aktuellen rechtlichen Anforderungen entspricht. Für Ihren Besuch gilt die jeweils
                                aktuelle Fassung.
                            </p>
                        </Section>

                        <p className="text-xs text-aimploy-muted pt-6 border-t border-black/5">
                            Hinweis: Diese Datenschutzerklärung wurde nach bestem Wissen erstellt. Wir empfehlen eine
                            abschließende Prüfung durch einen Rechtsanwalt oder Datenschutzbeauftragten vor produktivem
                            Einsatz.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div>
            <h2 className="font-display text-2xl font-bold mb-4">{title}</h2>
            <div className="text-sm text-aimploy-muted leading-relaxed space-y-3 [&_a]:break-words [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_code]:bg-aimploy-bg [&_code]:px-1 [&_code]:rounded">
                {children}
            </div>
        </div>
    );
}
